
















import Vue from 'vue';

import Parts from '@/components/Money/Parts.vue';
import {Component, Prop} from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';

@Component({
  components: {Icon, Parts},
})


export default class Number extends Vue {
  @Prop() type!: string
  @Prop() value!: number
  
  get commaAmount(){
    return this.value.toString().replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  onValueChanged(event:InputEvent){
    const input = (event.currentTarget as HTMLInputElement)
    const output = parseFloat(input.value.replace(/,/g, ''));
    this.$emit('update:value',output)
  }
};
